export const localKeyGenByVedaBreakpointsOfResponsiveField = 'KeyGenByVedaBreakpointsOfResponsiveField';
